module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"charging":"Charging","chargingNot":"Not charging","errors":"DTC Codes"},"de":{"charging":"Aufladend","chargingNot":"Nicht aufladend","errors":"DTC Codes"},"fr":{"charging":"Chargement","chargingNot":"Pas de charge","errors":"DTC Codes"},"it":{"charging":"Ricarica","chargingNot":"Non in carica","errors":"DTC Codes"}}')
  delete Component.options._Ctor
}
